// src/utils/extractApiError.js
import i18n from "../i18n";

export default function extractApiError(error, fallback = "An error occurred, please try again.") {
  const messages = [];
  const status = error?.response?.status;
  const data = error?.response?.data;

  const pushStr = (s) => {
    const t = String(s ?? "").trim();
    if (t) messages.push(t);
  };

  const fromObject = (obj, prefix = "") => {
    Object.entries(obj).forEach(([k, v]) => {
      const label = prefix ? `${prefix}.${k}` : k;
      if (Array.isArray(v)) {
        v.forEach((item) => pushStr(`${label}: ${item}`));
      } else if (v && typeof v === "object") {
        fromObject(v, label);
      } else {
        pushStr(`${label}: ${v}`);
      }
    });
  };

  // Prefer structured fields
  const d = data?.details;
  if (d) {
    if (typeof d === "string") {
      pushStr(d);
    } else if (Array.isArray(d)) {
      d.forEach((item) => {
        if (typeof item === "string") pushStr(item);
        else if (item && typeof item === "object") fromObject(item);
        else pushStr(item);
      });
    } else if (typeof d === "object") {
      fromObject(d);
    }
  }

  if (messages.length === 0 && typeof data?.message === "string" && data.message.trim()) {
    pushStr(data.message);
  }
  // Map validation errors array
  if (messages.length === 0 && Array.isArray(data?.errors)) {
    data.errors.forEach((e) => {
      if (e && typeof e === 'object') {
        if (e.field && e.message) pushStr(`${e.field}: ${e.message}`);
        else if (e.message) pushStr(e.message);
      } else {
        pushStr(e);
      }
    });
  }
  if (messages.length === 0 && error?.message) {
    pushStr(error.message);
  }
  if (messages.length === 0) {
    pushStr(fallback);
  }

  // ترجمة الرسائل إن توفرت مفاتيح ضمن errors
  const t = i18n.t.bind(i18n);
  const translated = messages.map((m) => {
    const key = `errors.${m}`;
    const res = t(key);
    return res === key ? m : res;
  });

  const unique = Array.from(new Set(translated));
  // للحفاظ على التوافق مع الاستدعاءات الحالية: نُعيد مصفوفة الرسائل فقط
  return unique;
}
